import React from "react";
import { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { Link, NavLink, useNavigate } from "react-router-dom";
import {
  Box,
  Drawer,
  List,
} from "@mui/material";
import { SidebarWidth } from "../../../assets/global/Theme-variable";
import LogoIcon from "../Logo/LogoIcon";
import Copyright from "../Footer/Copyright";

import SidebarItem from "./SideItem";
import Menuitems from "./SideBarMenu";

const Sidebar = ({ isSidebarOpen }) => {

  const location = useLocation();
  const [openParent, setOpenParent] = useState(null);
  const [selectedId, setSelectedId] = useState(null);

  const navigate = useNavigate();

  const handleToggle = (href) => {
    console.log('setOpenParent() openParent:' + openParent + ' -> ' + href);
    setOpenParent(prev => (prev === href ? null : href));
    navigate(href);
  };

    useEffect(() => {
    const path = location.pathname;

    for (const parent of Menuitems) {                                          // Search for which item or child matches the path

      if (parent.href === path) {                                         // parent directly matches   
        setOpenParent(parent.href);
        setSelectedId(parent.href);
        return;
      }
      if (parent.children) {                                               // children match
        const foundChild = parent.children.find(c => c.href === path);
        if (foundChild) {
          setOpenParent(parent.href);      // expand parent
          setSelectedId(foundChild.href);  // highlight child
          return;
        }
      }
    }
  }, [location.pathname, Menuitems]);
  
 
  const SidebarContent = (
    <Box sx={{ p: 3, height: "calc(100vh - 40px)" }}>
      <Link to="/">
        <Box sx={{ display: "flex", alignItems: "Center" }}>
          <LogoIcon />
        </Box>
      </Link>

      <Box>
        <List sx={{ mt: 4, }} >
          {Menuitems.map((item) => {
            return (
                      <SidebarItem 
                          key={item.href} 
                          item={item} 
                          openParent={openParent}
                          selectedId={selectedId}
                          setSelectedId={setSelectedId}
                          setOpenParent={setOpenParent}

                          onToggle={handleToggle}
                      />
                );
          })}
        </List>
      </Box>

    </Box>
  );

  return (
      <Drawer anchor="left" open={isSidebarOpen} variant="persistent" PaperProps={{ sx: { width: SidebarWidth, }, }} >
        {SidebarContent}
        <Box sx={{ display: "flex", alignItems: "Center" }}>
          <Copyright />
        </Box>
      </Drawer>
  );
};

export default Sidebar;
